import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
// import BannerImage from "../../../components/assets/banner.png";
// import CarChaserHeader from "../../components/Header/Header";
import { useTranslation } from "react-i18next";
import carchaserWhiteLogo from "../../../components/assets/carchaser-white-logo.svg";
import HeroImg from "../../../components/assets/hero-img.png";
import theme from "../../../theme";
import { setAuthAction } from "../../../toolkit/auth/authSlice";
import { setActiveSidebar } from "../../../toolkit/sidebar/sidebarSlice";
import {
  useLazySigninQuery,
  useVerifyOtpHandlerMutation,
} from "../../../toolkit/signin/signinApi";
import { routes } from "../../../utils/constants/routes";
import { SidebarOptions } from "../../../utils/constants/sidebar";
import OTPInput from "./components/OTPVerification";
import { setAlertDialog } from "../../../toolkit/alertDialog/alertDialogSlice";
import { USER_ROLES, USER_ROLES_DOMAINS } from "@common/utils/constants/users/userRoles";

const SignIn = () => {
  // static data start...
  const signinStates = React.useMemo(() => {
    return {
      credentials: "credentials",
      otpVerification: "otpVerification",
    };
  }, []);
  // static data end...

  const isMobile = useMediaQuery("(max-width:1300px)");

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // custom hook calls start...
  const { t } = useTranslation("auth");
  const [signinHandler, signinData] = useLazySigninQuery();
  const [verifyOtpApiHandler, verifyOtpApiData] =
    useVerifyOtpHandlerMutation();
  // custom hook calls end...

  // useState variables start...
  const [signinState, setSigninState] = React.useState(
    signinStates?.credentials
  );
  const [signinUserRole, setSigninUserRole] = React.useState("");
  // useState variables end...

  // Initial form values
  const navigate = useNavigate();
  const initialValues = {
    phone: "",
  };

  // form schema start...
  // Phone number validation schema
  const SignInSchema = Yup.object().shape({
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, t("phoneInvalid"))
      .required(t("phoneRequired")),
  });

  const signInFormik = useFormik({
    initialValues,
    validationSchema: SignInSchema,
    onSubmit: async (values) => {

      // await verifyOtpHandler(123);

      const res = await signinHandler({
        phone: values?.phone,
      });

      console.log(res, "Signin");

      if (res?.error || !res?.data?.status) {
        dispatch(
          setAlertDialog({
            open: true,
            title: `Error!`,
            message: res?.error?.data?.message || res?.data?.message || `Some error occured!`
          })
        )
      } else if (res?.data?.status) {
        dispatch(
          setAuthAction({
            isNewUser: true,
          })
        );
        setSigninState(signinStates?.otpVerification);
      }
    },
  });

  const verifyOtpHandler = async (otp) => {
    const res = await verifyOtpApiHandler({
      payload: {
        ...signInFormik?.values,
        otp,
      },
    });

    console.log(res, `verifyOtpApiHandler`);

    if (res?.error || !res?.data?.status) {
      dispatch(
        setAlertDialog({
          open: true,
          title: `Error!`,
          message: res?.error?.data?.message || res?.error?.data?.error || `Some error occured!`
        })
      );
    } else if (res?.data?.status) {
      const { message, ...rest } = verifyOtpApiData?.data || {};
      dispatch(setAuthAction({
        ...rest,
        user_name: res?.data?.user_name,
        user_role: USER_ROLES.dealer
      }));
      dispatch(setActiveSidebar(SidebarOptions[SidebarOptions.length - 2]));
      navigate(routes.dashboardNavigation);
    }
  };
  // Handlers end...

  // useEffect start...
  // React.useEffect(() => {
  //   if (signinData?.isSuccess) {
  //     dispatch(
  //       setAuthAction({
  //         isNewUser: true,
  //       })
  //     );
  //     setSigninState(signinStates?.otpVerification);
  //   }
  // }, [signinData?.isSuccess]);

  // React.useEffect(() => {
  //   if (verifyOtpApiData?.isSuccess) {
  //     // sessionStorage.setItem("user_id", verifyOtpApiData?.data?.UserID);
  //     // sessionStorage.setItem("token", verifyOtpApiData?.data?.token);

  //     const { message, ...rest } = verifyOtpApiData?.data;
  //     dispatch(setAuthAction(rest));
  //     dispatch(setActiveSidebar(SidebarOptions[SidebarOptions.length - 2]));
  //     navigate(routes.dashboardNavigation);
  //   }
  // }, [verifyOtpApiData?.isSuccess]);

  // React.useEffect(() => {
  //   if (signinUserRole) {
  //     dispatch(
  //       setAlertDialog({
  //         open: true,
  //         title: `Alert!`,
  //         message: `Are you sure you want to sign in as ${signinUserRole}?`,
  //         onOk: () => {
  //           window.location = USER_ROLES_DOMAINS[signinUserRole]
  //         }
  //       })
  //     )
  //   }
  // }, [signinUserRole]);
  // useEffect end...

  return (
    <>
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          margin: "0 auto",
        }}
      >
        {!isMobile ? <Grid
          item
          sx={{
            width: "55%",
            borderRadius: "1.5rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "90vh",
            backgroundImage: `url(${HeroImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            p: 4,
            color: "white",
          }}
        >
          {/* <Typography variant="h4" fontWeight="bold">CAR CHASER</Typography> */}
          <img
            src={carchaserWhiteLogo}
            style={{
              width: "18rem",
            }}
          />

          <Box
            sx={{
              padding: "1rem",
              background: "rgba(0, 0, 0, 0.8)",
              borderRadius: "1rem",
            }}
          >
            <Typography variant="h6">{t("contactInformation")}</Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                  }}
                >
                  20-4534 Dufferin St,
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                  }}
                >
                  North York M3H 5X2
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                  }}
                >
                  Mon - Fri: 9am - 7pm
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                  }}
                >
                  Sat: 10am - 5pm | Sun: Closed
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                  }}
                >
                  Phone: 647-893-6208
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                  }}
                >
                  Email: contact@carchaser.ca
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid> : null}
        <Grid
          item
          sx={{
            width: isMobile ? "100%" : "40%",
            padding: "1rem 0 1rem 1rem",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            bgcolor: "#f8f9fa",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: isMobile ? "none" : "45rem",
              padding: "1.5rem 2rem !important",
              boxShadow: 3,
              borderRadius: "1.5rem",
              bgcolor: "white",
            }}
          >
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              {/* Dealer Sign-In */}
              {t("dealerSignIn")}
            </Typography>
            <Typography variant="subtitle1" color="primary" gutterBottom>
              {t("Welcome to CAR CHASER")}
              {/* Welcome to CAR CHASER */}
            </Typography>
            {signinState === signinStates?.credentials ? (
              <form onSubmit={signInFormik.handleSubmit}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid item sx={{ width: "100%" }}>
                    <TextField
                      fullWidth
                      label={t("phoneNumber")}
                      name="phone"
                      {...signInFormik.getFieldProps("phone")}
                      error={
                        signInFormik.touched.phone &&
                        Boolean(signInFormik.errors.phone)
                      }
                      helperText={
                        signInFormik.touched.phone && signInFormik.errors.phone
                      }
                    />
                  </Grid>
                </Grid>

                {/* <Box mt={2}>
                  <Typography
                    variant="body2"
                    gutterBottom
                    sx={{
                      color: theme.palette.text.primary,
                      padding: "1.5rem 0",
                      lineHeight: "1.35rem",
                    }}
                  >
                    Car-Chaser Technology needs the contact information you
                    provide to us to contact you about our products and
                    services. You may unsubscribe from these communications at
                    any time. For information on how to unsubscribe, as well as
                    our privacy practices and commitment to protecting your
                    privacy, please review our Privacy Policy.
                  </Typography>
                </Box> */}
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 2,
                    bgcolor: "#4c34f0",
                    color: "white",
                    borderRadius: "24px",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                  disabled={signinData?.isFetching}
                >
                  {signinData?.isFetching ? (
                    <CircularProgress
                      size={22}
                      sx={{
                        color: theme.palette.text.secondary,
                      }}
                    />
                  ) : (
                    t("signIn")
                  )}
                </Button>

                {/* <Typography
                  textAlign="center"
                  marginTop={2}
                  sx={{
                    color: theme.palette.text.primary,
                  }}
                >
                  {t("Forgot your password?")}{" "}
                  <Button
                    variant="text"
                    sx={{
                      padding: "0px",
                      minWidth: "0px",
                      fontWeight: "bold",
                      color: theme.palette.primary.main,
                      textTransform: "none",
                      textDecoration: "underline",
                      "&:hover": {
                        backgroundColor: "transparent",
                        textDecoration: "underline",
                      },
                    }}
                    onClick={() => {
                      // Handle sign-in navigation, e.g. navigate("/login")
                      navigate(routes.resetPassword);
                    }}
                  >
                    {t("Reset it")}
                  </Button>
                </Typography> */}

                <Typography
                  textAlign="center"
                  marginTop={2}
                  sx={{
                    color: theme.palette.text.primary,
                  }}
                >
                  {t("noAccount")}{" "}
                  <Button
                    variant="text"
                    sx={{
                      padding: "0px",
                      minWidth: "0px",
                      fontWeight: "bold",
                      color: theme.palette.primary.main,
                      textTransform: "none",
                      textDecoration: "underline",
                      "&:hover": {
                        backgroundColor: "transparent",
                        textDecoration: "underline",
                      },
                    }}
                    onClick={() => {
                      // Handle sign-in navigation, e.g. navigate("/login")
                      navigate(routes.authSignup);
                    }}
                  >
                    {t("signUp")}
                  </Button>
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.25rem"
                  }}
                >
                  <Typography
                    textAlign="center"
                    marginTop={2}
                    sx={{
                      color: theme.palette.text.primary,
                    }}
                  >
                    <Button
                      variant="text"
                      sx={{
                        padding: "0px",
                        minWidth: "0px",
                        fontWeight: "bold",
                        color: theme.palette.primary.main,
                        textTransform: "none",
                        // textDecoration: "underline",
                        "&:hover": {
                          backgroundColor: "transparent",
                          // textDecoration: "underline",
                        },
                      }}
                      onClick={() => {
                        // Handle sign-in navigation, e.g. navigate("/login")
                        // navigate();
                        window.location = USER_ROLES_DOMAINS.seller;
                      }}
                    >
                      Sign in as a Seller
                    </Button>
                  </Typography>
                </Box>
              </form>
            ) : (
              <OTPInput
                onVerify={verifyOtpHandler}
                onResend={signInFormik?.handleSubmit}
                isSubmitting={verifyOtpApiData?.isLoading}
              />
            )}
          </Box>
        </Grid>
      </Grid>

      {/* <Box bgcolor={"#f5f5f5"} display={"flex"} flexDirection="column" gap={2}>
        <Box display="flex" flexDirection="column" maxHeight={"100vh"} px={4}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            gap={4}
            mb={2}
            py={4}
            width="100%"
            alignItems="stretch" // Changed from "center" to "stretch" for equal height
            height="100%"
            maxHeight={"calc(100vh - 100px)"} // Adjusted to account for header height
          >
            <Box display={{ sm: "none", lg: "flex" }} flex={1}>
              <AuthImagePanel imageSrc={BannerImage} />
            </Box>

            <Paper
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                justifyContent: "center",
                px: 8,
                py: 4,
                borderRadius: 8,
                boxShadow: "none",
                width: { xs: "100%", lg: "60%" }, // Fixed width on large screens
                gap: 10,
                flexShrink: 0,
                maxWidth: 600,
                maxHeight: "100%", // Constrain to parent height
              }}
            >
              <Box>
                <Typography component="h1" variant="h4" fontWeight={600} mb={2}>
                  {t("signInHeader")}
                </Typography>
                <Typography fontSize={"20px"} color="text.primary">
                  {t("signInSubtext")}
                </Typography>
              </Box>
              {signinState === signinStates?.credentials ? (
                <form
                  style={{
                    width: "100%",
                    margin: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 36,
                  }}
                  onSubmit={signInFormik?.handleSubmit}
                >
                  <Box>
                    <FormLabel
                      htmlFor="phone"
                      sx={{
                        color: "text.primary",
                        fontSize: "20px",
                        mb: 0,
                      }}
                    >
                      {t("phoneNumber")}
                    </FormLabel>
                    <TextField
                      // as={TextField}
                      name="phone"
                      value={signInFormik?.values?.phone}
                      onChange={signInFormik?.handleChange}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      error={
                        signInFormik?.touched.phone &&
                        Boolean(signInFormik?.errors.phone)
                      }
                      helperText={
                        signInFormik.touched.phone && signInFormik?.errors.phone
                      }
                      placeholder="Enter your phone number"
                    />
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    width={"100%"}
                  >
                    <PrimaryButton
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      disabled={signinData?.isFetching}
                      sx={{
                        width: "100%",
                        minWidth: "10rem",
                        padding: "1rem 0",
                      }}
                    >
                      {signinData?.isFetching ? (
                        <CircularProgress size={22} />
                      ) : (
                        "Sign In"
                      )}
                    </PrimaryButton>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      Don't have an account?
                      <Button
                        color="primary"
                        size="small"
                        sx={{
                          ml: 1,
                          textTransform: "none",
                          textDecoration: "underline",
                        }}
                        onClick={() => {
                          navigate("/signup");
                        }}
                      >
                        Register Now
                      </Button>
                    </Typography>
                  </Box>
                </form>
              ) : (
                <OTPInput
                  onVerify={verifyOtpHandler}
                  onResend={signInFormik?.handleSubmit}
                  isSubmitting={verifyOtpApiData?.isFetching}
                />
              )}
            </Paper>
          </Box>
        </Box>
      </Box> */}
    </>
  );
};

export default SignIn;
